import ButtonLink from '@/common/components/ButtonLink'
import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { TicketData } from '@/common/types/support/ticket.type'
import { BriefcaseBusinessIcon, ChevronRightIcon, UserRoundIcon } from 'lucide-react'

type SupportTicketCreatorProps = {
  creator: TicketData['creator']
  branch: TicketData['branch']
}

export const SupportTicketCreator = ({ creator, branch }: SupportTicketCreatorProps) => {
  const isFromAdmin = !creator?.branch && !creator?.company;

  const companyId = branch?.company?.id

  const linkByCompanyType =
    (isFromAdmin && branch?.company?.kind) ||
    (!isFromAdmin && creator?.branch)
      ? `/companies/${companyId}`
      : `/establishments/${companyId}`

  const creatorButtonPermissionKlass = isFromAdmin ? 'Admin::Users::Show' : branch?.company?.kind ? 'Admin::Client::Users::Show' : 'Admin::Establishment::Users::Show'

  const companyButtonPermissionKlass = branch?.company?.kind ? 'Admin::Client::Companies::Show' : 'Admin::Establishment::Companies::Show'

  return (
    <div className="flex gap-3 items-center">
      <ButtonLink
        linkTo={isFromAdmin ? `/users/${creator.id}` : `${linkByCompanyType}/users/${creator.id}`}
        operationKlassToCheckPermission={creatorButtonPermissionKlass}
        dataTestId="creator_clickable_link"
      >
        <ImageWithPlaceholder
          url={creator?.profile_picture?.url}
          alt={creator?.full_name}
          placeholderIcon={UserRoundIcon}
          className="size-6"
          iconClassName="size-4"
        />

        <div className='flex gap-1 items-center'>
          <p className="text-xs">{creator?.full_name}</p>

          {isFromAdmin && (
            <p className='text-sm font-light italic'>(Agente Tcard)</p>
          )}
        </div>
      </ButtonLink>

      {isFromAdmin ? (
        <ButtonLink
          linkTo={linkByCompanyType}
          operationKlassToCheckPermission={companyButtonPermissionKlass}
          dataTestId="company_clickable_link"
        >
          <ChevronRightIcon strokeWidth={1.5} size={16} />

          <div className="flex gap-2 items-center">
            <ImageWithPlaceholder
              url={
                branch?.company?.general_information?.company_logo?.url
              }
              placeholderIcon={BriefcaseBusinessIcon}
              className="size-6"
              iconClassName="size-4"
            />

            <div>
              <p className="text-xs font-bold">
                {branch?.company?.general_information?.fantasy_name}
              </p>

              {!!branch?.display_name && (
                <p className="text-xs font-light">
                  {branch?.display_name}
                </p>
              )}
            </div>
          </div>
        </ButtonLink>
      ) : (
        <ButtonLink
          linkTo={linkByCompanyType}
          operationKlassToCheckPermission={companyButtonPermissionKlass}
          dataTestId="company_clickable_link"
        >
          <div className="flex gap-2 items-center">
            <ImageWithPlaceholder
              url={
                creator?.branch?.general_information?.company_logo?.url ||
                creator?.company?.general_information?.company_logo?.url
              }
              alt={creator?.branch?.display_name || creator?.company?.general_information?.fantasy_name}
              placeholderIcon={BriefcaseBusinessIcon}
              className="size-6"
              iconClassName="size-4"
            />

            <div className='flex flex-col items-start'>
              <p className="text-[12px] font-bold">
                {creator.company?.general_information?.fantasy_name}
              </p>

              {!!creator.branch?.display_name && (
                <p className="text-[11px] font-light">
                  {creator.branch?.display_name}
                </p>
              )}
            </div>
          </div>
        </ButtonLink>
      )}
    </div>
  )
}
